// extracted by mini-css-extract-plugin
export default {"card":"Q4-z"};